"use strict";
// @ts-ignore
try {
    self['workbox:navigation-preload:6.5.2'] && _();
}
catch (e) { }
